import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';

//配置信息
const cookieName = 'container_back'; // 启动时自动生成，无需手工配置
//---------------------------------------------------

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null,
    token: null,
    loading: false,
    cookieName: 'cargo',
    adminFlag: false,
    isVisitor: true, //是否为游客
    menuList: [],
    menuTree: [],
    menuActive: {},
    menuTab: [],
    fileList: [],
    sysList: [],
    checkLang: false,
    companyCheckFlag: false,
    auth: []
  },
  mutations,
  actions,
  modules: {}
});
